<template>
  <div class="dashboard">
    <tabs parent="dashboard"
    >
      <tab
          id="map"
          :name="translate('maps')"
          :href="url+'/map'"
          :is-visible="isTabVisible('maps')"
      >
        <Maps />
      </tab>

      <tab
          id="stats"
          :name="translate('stats')"
          :href="url+'/stats'"
          :is-visible="isTabVisible('stats')"
      >
        <Stats />
      </tab>

      <tab
          id="tariff_traffic"
          :name="translate('dashboard.traffic.title')"
          :href="url+'/tariff_traffic'"
          :is-visible="isTabVisible('tariff_traffic')"
      >
        <TariffTraffic />
      </tab>

      <tab
          id="unlimited"
          :name="translate('dashboard.unlimited.title')"
          :href="url+'/unlimited'"
          :is-visible="isTabVisible('unlimited')"
      >
        <Unlimited />
      </tab>

      <tab
          id="simcards_traffic"
          :name="translate('dashboard.simcards_traffic.title')"
          :href="url+'/simcards_traffic'"
          :is-visible="isTabVisible('simcards_traffic')"
      >
        <SimcardsTraffic />
      </tab>

    </tabs>
  </div>
</template>
<script>
import Maps from './Tabs/Maps/Index.vue';
import Stats from './Tabs/Stats/Index.vue'
import TariffTraffic from "./Tabs/TariffTraffic/Index.vue";
import SimcardsTraffic from "./Tabs/SimcardsTraffic/Index.vue";
import Unlimited from "./Tabs/Unlimited/Index.vue";

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Dashboard',
  components: {
    Tab,
    Tabs,
    Maps,
    Stats,
    TariffTraffic,
    SimcardsTraffic,
    Unlimited
  },
  data () {
    return {
    }
  },

  computed:{
    url () { return '/dashboard' },
    permissions(){
      return this.$store.getters.getPermissions
    },
  },

  methods: {
    isTabVisible(tab) {
      switch(tab) {
        case 'maps': return (this.$store.getters.getPermissions.viewDashboardMap === true);
        case 'stats': return (this.$store.getters.getPermissions.viewDashboardStats === true);
        case 'tariff_traffic': return (this.$store.getters.getPermissions.viewDashboardTraffic === true);
        case 'unlimited': return (this.$store.getters.getPermissions.viewDashboardUnlimTraffic === true);
        case 'simcards_traffic': return (this.$store.getters.getPermissions.permissionGod === true);
      }
      return false;
    },

  },

}
</script>
<style lang="scss" scoped>
  .dashboard {
    width: 100%;
    height: 100%;

    &::-webkit-scrollbar {
      width: 10px;
    }
  }
</style>
